import * as yup from 'yup'

export const schemaData = yup.object().shape({
  nfId: yup.string().required(),
  amount: yup
    .number()
    .positive()
    .required(),
  urlInvoice: yup
    .string()
    .url()
    .required(),
  authenticityCode: yup.string().required(),
  issuedAt: yup.string().when('status', {
    is: status => status === 'issued',
    then: yup.string().required(),
  }),
  canceledAt: yup.string().when('status', {
    is: status => status === 'canceled',
    then: yup.string().required(),
  }),
  reason: yup.string().when('status', {
    is: status => status === 'canceled',
    then: yup.string().required(),
  }),
})

export default schemaData
